<template>
  <BCard no-body class="w-100">
    <BCardBody class="dashboard-align">
      <div class="pie-chart-container">
        <apexchart
          v-if="screenWidth > 400"
          class="apex-charts"
          :height="chartHeight"
          type="pie"
          dir="ltr"
          :series="pieChart.series"
          :options="pieChart.chartOptions"
        ></apexchart>
      </div>
      <div>
        <span class="dashboard-heading">{{ assetAllocationTitle }}</span>
        <div class="text-muted mt-1">
          <div class="asset-allocation">
            <span class="dashboard-assetper">Equity: </span>
            <span>{{ equityPercentage + perSymbol }}</span>
            <span class="color-bar" style="background-color: #1fd19f"></span>
            <span class="dashboard-assetper"> | Debt: </span>
            <span>{{ debtPercentage + perSymbol }}</span>
            <span class="color-bar" style="background-color: #f2f231"></span>
            <span class="dashboard-assetper"> | Other: </span>
            <span>{{ otherPercentage + perSymbol }}</span>
            <span class="color-bar" style="background-color: #7669ae"></span>
          </div>
        </div>
      </div>
    </BCardBody>
  </BCard>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AssetAllocation",
  data() {
    return {
      rupeeSymbol: "₹",
      perSymbol: "%",
      equityPercentage: "",
      debtPercentage: "",
      otherPercentage: "",
      assetAllocationTitle: "My Asset allocation",
      defaultHeight: 100,
      smallScreenHeight: 90,
      screenWidth: window.innerWidth,
      pieChart: {
        chart: {
          height: 50,
        },
        series: [],
        chartOptions: {
          labels: ["Equity", "Debt", "Other"],
          colors: ["#1FD19F", "#F2F231", "#7669AE"],
          legend: {
            position: "bottom",
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            enabled: true,
            followCursor: true,
            fixed: {
              enabled: false
            },
            intersect: false,
            shared: false,
            custom: function({ series, seriesIndex, w }) {
              const label = w.globals.labels[seriesIndex];
              const value = series[seriesIndex];
              const color = w.globals.colors[seriesIndex];
              const textColor = seriesIndex === 1 ? 'black' : 'white';
              return `
                <div style="
                  background: ${color};
                  color: ${textColor};
                  padding: 8px 12px;
                  border-radius: 6px;
                  font-size: 12px;
                  font-weight: 600;
                  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
                  white-space: nowrap;
                  z-index: 999999 !important;
                  position: fixed !important;
                  transform: translateY(-100%);
                  right: 10px;
                  top: 40px;
                ">
                  ${label}: ${value}%
                </div>
              `;
            },
            style: {
              fontSize: '12px',
              fontFamily: undefined
            }
          },
          responsive: [],
        },
      },
    };
  },
  computed: {
    ...mapGetters(["myPortfolio", "portfolioType", "holdingType"]),
    portfolioData() {
      return this.portfolioType === "own"
        ? this.myPortfolio?.ownPortfolio
        : this.myPortfolio?.familyPortfolio;
    },
    chartHeight() {
      return this.screenWidth <= 1100
        ? this.smallScreenHeight
        : this.defaultHeight;
    },
  },
  methods: {
    updateChartSeries() {
      this.pieChart.series = [
        parseFloat(this.equityPercentage) || 0,
        parseFloat(this.debtPercentage) || 0,
        parseFloat(this.otherPercentage) || 0,
      ];
    },
    
    processPortfolioData() {
     const data = this.portfolioData;
    if (!data) return;

    let equity = 0;
    let debt = 0;
    let other = 0;
    let total = 0;
    if (this.holdingType === 'all') {
    const mfEquity = Number(data.assetAllocation?.equity) || 0;
    const mfDebt   = Number(data.assetAllocation?.debt)   || 0;
    const mfOther  = Number(data.assetAllocation?.other)  || 0;
    const stockEquity = Number(data.stockPortfolio?.stockAssetAllocation?.equity) || 0;
    const stockDebt   = Number(data.stockPortfolio?.stockAssetAllocation?.debt)   || 0;
    const stockOther  = Number(data.stockPortfolio?.stockAssetAllocation?.other)  || 0;
    equity = mfEquity + stockEquity;
    debt   = mfDebt + stockDebt;
    other  = mfOther + stockOther;
    total  = equity + debt + other;   
  } 
  else if (this.holdingType === 'stocks' && data.stockPortfolio?.stockAssetAllocation) {
    equity = Number(data.stockPortfolio.stockAssetAllocation.equity) || 0;
    debt   = Number(data.stockPortfolio.stockAssetAllocation.debt)   || 0;
    other  = Number(data.stockPortfolio.stockAssetAllocation.other)  || 0;
    total  = equity + debt + other;   
  } 
  else if (this.holdingType === 'mutualfunds' && data.assetAllocation) {
    equity = Number(data.assetAllocation.equity) || 0;
    debt   = Number(data.assetAllocation.debt)   || 0;
    other  = Number(data.assetAllocation.other)  || 0;
    total  = equity + debt + other;   
  }
  if (total > 0) {
    this.equityPercentage = ((equity / total) * 100).toFixed(1);
    this.debtPercentage   = ((debt / total) * 100).toFixed(1);
    this.otherPercentage  = ((other / total) * 100).toFixed(1);
  } else {
    this.equityPercentage = this.debtPercentage = this.otherPercentage = 0;
  }
    this.assetAllocationTitle =
      this.portfolioType === "own"
        ? "My Asset allocation"
        : "My family's asset allocation";
    this.updateChartSeries();
  },
  },
  watch: {
    portfolioType: "processPortfolioData",
    holdingType: "processPortfolioData",
    myPortfolio: {
      handler() {
        this.processPortfolioData();
      },
      immediate: true,
    },
  },
  mounted() {
    this.processPortfolioData();
  },
};
</script>

<style scoped>
.pie-chart-container {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 75px;
}

.color-bar {
  display: inline-block;
  margin-left: 4px;
  width: 18px;
  height: 9px;
  margin-bottom: -1px;
}

.dashboard-heading {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  color: #012e40;
}

.dashboard-assetper {
  left: 37.34%;
  right: 42.97%;
  top: 25.36%;
  bottom: 72.96%;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #1e1e1e;
}
.asset-allocation {
  font-size: 14px;
  color: #333;
}
.dashboard-align {
  box-sizing: border-box;
  background: linear-gradient(180deg, #ffffff 0%, #b3d4ff 100%);
  backdrop-filter: blur(5px);
  border-radius: 5px;
  padding: 6px 12px;
}

@media only screen and (max-width: 1000px) {
  .pie-chart-container {
    top: -6px;
  }
}


.debt-text {
  color: white;
}

/* Ensure tooltip appears above all content */
.apexcharts-tooltip {
  z-index: 999999 !important;
  position: fixed !important;
}

/* Ensure tooltip container is above everything */
.apexcharts-tooltip-series-group {
  z-index: 999999 !important;
  position: fixed !important;
}

/* Override any parent z-index constraints */
.apexcharts-tooltip.apexcharts-theme-light {
  z-index: 999999 !important;
  position: fixed !important;
}

/* Force tooltip to appear above content */
.apexcharts-tooltip.apexcharts-tooltip-active {
  z-index: 999999 !important;
  position: fixed !important;
}

@media only screen and (max-width: 500px) {
  .dashboard-align {
    padding: 12px 12px 10px 12px;
  }

  .asset-allocation {
    font-size: 10px;
  }
}


</style>
